"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendTemplate = exports.getTemplateData = exports.getByGroup = exports.create = exports.update = exports.getAll = exports.get = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var lib_1 = require("./lib");
var base = '/api/email-template';
function get(templateId, isCustom) {
    return api_1.default
        .get("".concat(base, "/").concat(templateId).concat(isCustom ? '?isCustom=true' : ''))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.get = get;
function getAll() {
    return api_1.default.get("".concat(base)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAll = getAll;
function update(id, template) {
    return api_1.default.put("".concat(base, "/").concat(id), template).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.update = update;
function create(data) {
    return api_1.default.post("".concat(base), data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
function getByGroup(group, isCustom) {
    var fields = ['id', 'name', 'groupDefault'];
    var queryParams = query_string_1.default.stringify({ fields: fields, isCustom: isCustom });
    return api_1.default.get("".concat(base, "/group/").concat(group, "?").concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getByGroup = getByGroup;
function getTemplateData(url, templateName) {
    var base = url.split('?')[1];
    if (templateName.includes('follow_up') || !base) {
        url = (0, lib_1.addQueryParams)(url, { templateName: templateName });
        return api_1.default.get(url).then(api_1.extractData).catch(api_1.errorHandler);
    }
    var data = base.split('&').map(function (s) {
        var _a;
        return (_a = {}, _a[s.split('=')[0]] = s.split('=')[1], _a);
    });
    var payload = {
        templateName: templateName,
        segmentId: parseInt(data.find(function (d) { return d.segmentId; }).segmentId),
        expertIds: data.filter(function (d) { return d.expertIds; }).map(function (id) { return parseInt(id.expertIds); }),
    };
    return api_1.default.post('/api/expert-project-link/expert-invite-template', payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getTemplateData = getTemplateData;
function sendTemplate(url, template) {
    return api_1.default.post(url, template).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.sendTemplate = sendTemplate;
var api = {
    get: get,
    getAll: getAll,
    update: update,
    getByGroup: getByGroup,
    getTemplateData: getTemplateData,
    sendTemplate: sendTemplate,
    create: create,
};
exports.default = api;
